import type { Branded } from './branded'
import type { DomainId } from './domain'

type ProjectId = Branded<string, 'ProjectId'>
type UserId = Branded<string, 'UserId'>

const projectId = (value: string): ProjectId => value as ProjectId
const userId = (value: string): UserId => value as UserId

type Project = {
	readonly id: ProjectId
	readonly domainId: DomainId
	readonly slug: string
	readonly name: string
	readonly descr: string
	readonly archived: boolean
	readonly createdAt: Date
	readonly updatedAt: Date
}

export { projectId, userId }
export type { Project, ProjectId, UserId }
